import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, Renderer2 } from '@angular/core';
import { Carrier } from '../carrier/carrier';
import { CarrierUtility } from '../utils/carrier-utility';
import { ContainerItem } from '../carrier/carrieritem';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from "../utils/error-handler";
import { isUndefined } from 'util';
import { BBAPIError } from '../carrier/api-error';
import { MaterialType, CarrierType } from '../carrier/carrier-enum';
import { CarrierGridService } from './carrier-grid.service';
import { OriginalMaterialType } from '../carrier/sample';
import { SRTubeValidationRequest } from './srtubevalidationrequest';

@Component({
  selector: 'app-carrier-grid',
  templateUrl: './carrier-grid.component.html',
  styleUrls: ['./carrier-grid.component.css']
})
export class CarrierGridComponent implements OnInit, OnChanges, AfterViewInit {

  constructor(private carrierGridService: CarrierGridService, private messagesService: MessagesService, private renderer: Renderer2) { }
  @Input() storeLocation: string;
  @Input() storeVertical: boolean;
  @Input() selectedCarrier: Carrier;
  @Input() bbApiError: BBAPIError;
  @Input() carriers: Carrier[];
  @Input() hasToggle: boolean;
  @Input() rows: number;
  @Input() cols: number;
  @Input() containerItems: Array<ContainerItem>;
  @Output() updatedCarrierEmitter = new EventEmitter();
  @Output() focusLocationEmitter = new EventEmitter();
  @Output() isVerticalEmitter = new EventEmitter();

  letters: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  numericList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  headerColumnsA1AndB1: number[] = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  headerRowsA1AndA2: string[] = ["A", "C", "E", "G", "I", "K", "M", "O"];
  headerColumnsA2AndB2: number[] = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  headerRowsB1AndB2: string[] = ["B", "D", "F", "H", "J", "L", "N", "P"];
  headerColumnsFor384Well: number[];
  headerRowsFor384Well: string[];

  headerColumns: number[];
  headerRows: string[];
  isVertical = false;
  carrierUtil: CarrierUtility = new CarrierUtility();
  errorHandler: ErrorHandler = new ErrorHandler;
  carrierState: string;
  originalMaterialType: OriginalMaterialType;
  originalMaterialTypeForFirstBarcode: OriginalMaterialType;
  count: number = 0;
  srTubeValidationRequest: SRTubeValidationRequest = new SRTubeValidationRequest();
  blocked: boolean;
  cachedBarcode: string;

  @Input() isCarrier: boolean;

  selectedQuadrant: Carrier = null;
  selectedA1Carrier: Carrier = null;
  selectedA2Carrier: Carrier = null;
  selectedB1Carrier: Carrier = null;
  selectedB2Carrier: Carrier = null;
  selectedReactionPlate: Carrier;
  storeCarrier: Carrier = null;
  isReplacement = false;
  isBarcodeChanged = false;
  ngOnInit() {
    this.carrierState = "WIP";
    if (this.selectedCarrier != undefined && this.selectedCarrier.wellType === "384-Well") {
      this.storeCarrier = new Carrier();
      this.storeCarrier.containerItems = new Array<ContainerItem>();
      this.selectedCarrier.containerItems.forEach(ci => {
        this.storeCarrier.containerItems.push(new ContainerItem(ci.barcode, ci.scanTime, ci.positionCol, ci.positionRow, ci.isInternal, ci.containerItemError))
      })
      this.getCarriersFromReactionPlate();
      this.selectedQuadrant = this.selectedA1Carrier;
      this.headerColumnsFor384Well = this.headerColumnsA1AndB1;
      this.headerRowsFor384Well = this.headerRowsA1AndA2;
    }
    if (this.storeVertical) {
      this.isVertical = this.storeVertical
    }
  }
  ngOnChanges() {

    this.headerRows = this.letters.slice(0, this.rows);
    this.headerColumns = this.numericList.slice(0, this.cols);
  }

  ngAfterViewInit() {
    if (this.storeLocation) {
      setTimeout(() => {
        var elem = this.renderer.selectRootElement('#' + this.storeLocation);
        this.renderer.listen(elem, "focus", () => { });
        elem.focus();
      }, 0);
    }
  }

  getStateAsString(selectedCarrier: Carrier): string {
    return this.carrierUtil.getStateAsString(selectedCarrier);
  }

  private getCarrierItemBarcode(i: number, j: number, selectedCarrier: Carrier): string {

    if (this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier) != null
      && this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier) != "")
      return this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier);

    else
      return this.carrierUtil.getCarrierItemErrorBarcode(i, j, selectedCarrier);
  }

  private getCarrierItemForIndex(selectedCarrier: Carrier, i: number, j: number): ContainerItem {
    return this.carrierUtil.getCarrierItemForIndex(selectedCarrier, i, j);
  }

  private getCarrierTypeAsString(selectedCarrier: Carrier): string {
    return this.carrierUtil.getCarrierTypeAsString(selectedCarrier);
  }

  //gets the primer Name from the container item
  private getCarrierItemPrimerName(i: number, j: number, selectedCarrier: Carrier): string {
    return this.carrierUtil.getCarrierItemPrimerName(i, j, selectedCarrier);
  }

  private isCarrierItemValid(i: number, j: number, item: Carrier): boolean {

    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return null;
    }
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    //Check for duplicates
    var isBarcodeDuplicate = currentItem !== null ? currentItem.hasDuplicate : false;

    //check for errors at thecarrierItem Level
    let isBarcodeValid = false
    if (currentItem !== undefined && currentItem != null &&
      currentItem.containerItemError !== undefined && currentItem.containerItemError != null) {
      isBarcodeValid = true
    }
    return isBarcodeDuplicate || isBarcodeValid;
  }

  /**
   * Checks availability of QC type in the GRID cell
   */
  isQcType(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);
    if (currentItem == null) return false;

    let material = currentItem.containerItemAware;

    // console.log("Material : " , material);
    if (material != undefined && material != null && material.type == 'QCSample') {

      return true;

    }

    // material.forEach(function(material) {

    //   if(material != null && material.type == MaterialType.QCSample) {
    //     return true;
    //   }
    // });

    return false;
  }

  /**
   * Extract Error, Qcsample information from containeritem
   * TODO Correct the logic for Reaction Plate with multiple material
   * @param carrierItem
   */
  getErrorTooltip(carrierItem: ContainerItem) {

    let tooltip: string = ""
    if (carrierItem != null && carrierItem.hasDuplicate)
      tooltip = "Duplicate Barcode";
    if (carrierItem != null && carrierItem.hasDifferntMaterials)
      tooltip = "Different Material";
    if (carrierItem !== undefined && carrierItem != null && carrierItem.containerItemError !== undefined && carrierItem.containerItemError != null
      && carrierItem.containerItemError.message !== undefined && carrierItem.containerItemError.message != null) {
      if (tooltip.length > 0) {
        tooltip = tooltip + ", " + carrierItem.containerItemError.message;
      } else {
        tooltip = tooltip + carrierItem.containerItemError.message;
      }
    }

    //Find qctype for QCSample type, show it is QC tooltip
    if (carrierItem !== undefined && carrierItem != null) {

      let material = carrierItem.containerItemAware;

      if (material != undefined && material != null) {

        if (material.type == 'QCSample') {
          tooltip = "QCSAMPLE-" + material.qcType + " " + tooltip;
        }

        if (material.inValid == true) {
          tooltip = "Barcode Not Registered " + tooltip;
        }

        if (material.reScanned == true) {
          tooltip = "Rescanned Barcode" + tooltip;
        }
      }
    }

    return tooltip;
  }

  private getCarrierItem(i: number, j: number, item: Carrier) {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return null;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null) {
      return currentItem;
    }
    return null;
  }

  onEnter(barcode: string, i, j, item: Carrier) {
    let row = i;
    let column = j;
    if (this.isVertical) {
      i = i + 1;
      if (i == 8) {
        i = 0;
        j = j + 1;
      }
      if (j < 12) {
        let focusLocation = 'textBox-' + item._id + i + j;
        this.focusLocationEmitter.emit(focusLocation);
        this.isVerticalEmitter.emit(this.isVertical);
        document.getElementById('textBox-' + item._id + i + j).focus();
      }
    } else {
      j = j + 1;
      if (j == 12) {
        j = 0;
        i = i + 1;
      }
      if (i < 8) {
        let focusLocation = 'textBox-' + item._id + i + j;
        this.focusLocationEmitter.emit(focusLocation);
        this.isVerticalEmitter.emit(this.isVertical);
        document.getElementById('textBox-' + item._id + i + j).focus();
      }
    }
    if (this.isSupremeRun(item)) {
      this.getCarrierByBarcode(barcode, row, column, item)
    }
  }

  private textareaChanged(newbarcode: string, i: number, j: number) {
    this.isBarcodeChanged = true;

    let currentItem: ContainerItem = this.getCarrierItemForIndex(this.selectedCarrier, i, j)
    if (currentItem) {
      this.isReplacement = currentItem.barcode != newbarcode
    }
    if (this.selectedCarrier.containerItems === null || isUndefined(this.selectedCarrier.containerItems)) {
      this.selectedCarrier.containerItems = new Array<ContainerItem>();
    }

    if (this.selectedCarrier === null) {
      return;
    }
    if (this.getStateAsString(this.selectedCarrier) == this.carrierState)
      this.selectedCarrier.isDirty = true;
    else
      this.selectedCarrier.isDirty = false;

    if (currentItem != null) {
      if (newbarcode == "") {
        var index = this.selectedCarrier.containerItems.indexOf(currentItem);
        this.selectedCarrier.containerItems.splice(index, 1);

        if (this.bbApiError != null && this.bbApiError.errors != null) {
          this.bbApiError.errors.forEach(element => {
            if (currentItem.barcode == element.code) {
              var errorIndex = this.bbApiError.errors.indexOf(element);
              this.bbApiError.errors.splice(errorIndex, 1);
            }
          });
        }

      }
      else
        currentItem.barcode = newbarcode;
    }
    else {
      let newCarrierItem: ContainerItem = new ContainerItem(newbarcode, 0, j + 1, i + 1, false, null);
      this.selectedCarrier.containerItems.push(newCarrierItem);
    }

    this.carriers.forEach(element => {
      if (element.barcode == this.selectedCarrier.barcode) {
        var carrierIndex = this.carriers.indexOf(element);
        this.carriers[carrierIndex].containerItems = this.selectedCarrier.containerItems;
        this.carriers[carrierIndex].isDirty = this.selectedCarrier.isDirty;
      }
    });
    this.checkForDuplicates();
  }

  private checkForDuplicates() {

    if (this.selectedCarrier === undefined || this.selectedCarrier === null) {
      return;
    }
    let carrierItemsOfSelectedCarrier: Array<ContainerItem> = this.selectedCarrier.containerItems;


    if (carrierItemsOfSelectedCarrier === undefined || carrierItemsOfSelectedCarrier === null || carrierItemsOfSelectedCarrier.length === 0) {
      return;
    }
    let barcodeMap: number[] = [];
    let count: number = 0;
    // collect amount per barcode
    carrierItemsOfSelectedCarrier.forEach(
      element => {
        let barcodeAmount: number = barcodeMap[element.barcode];
        if (barcodeAmount !== undefined && barcodeAmount !== null) {
          barcodeMap[element.barcode] = barcodeAmount + 1;
          if (barcodeAmount == 1) {
            count++;
          }
        }
        else {
          barcodeMap[element.barcode] = 1;
        }
      });
    this.selectedCarrier.errorCount = count;
    // mark the duplicates
    carrierItemsOfSelectedCarrier.forEach(
      element => {
        let barcodeAmount: number = barcodeMap[element.barcode];
        element.hasDuplicate = barcodeAmount > 1;
      });

  }

  /**
   * Checks availability of QC type in the GRID celif the barcode is rescanned
   */
  isReScanned(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    if (item.materialType != null && item.materialType.toString() == MaterialType.Primer.toString()) return false;
    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem == null) return false;
    let material = currentItem.containerItemAware;

    if (material != null && material != undefined) {
      if (material.reScanned == true) {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks if the barcode in the containerItem is registed in Blueberry
   */
  isNotRegistered(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem == null) return false;
    let material = currentItem.containerItemAware;

    if (material != null && material != undefined) {
      if (material.inValid == true) {
        return true;
      }
    }
    return false;
  }

  isPrimerPlate(item: Carrier) {
    // null check for carrier
    if (item == null && item == undefined) {
      return false;
    }
    // if the carriertype is TubeCarrier or PlateCarrier, then apply the CSS
    return item.carrierType != null && (item.carrierType.toString() === CarrierType.TUBE_RACK || this.isPlateCarrier(item))

  }

  isPlateCarrier(item: Carrier) {
    return item.carrierType.toString() === CarrierType.HAMILTON_CARRIER && item.materialType === MaterialType.Primer || item.carrierType.toString() === CarrierType.PLATE_CARRIER
  }

  // To check if the barcode is of a synthesized primer type
  isSynthesized(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    if (item.materialType != null && item.materialType.toString() === MaterialType.Sample.toString()) return false;
    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem == null) return false;
    let material = currentItem.containerItemAware;

    // checking if material type is primer
    if (material != null && material != undefined && material.materialType === MaterialType[3]) {
      if (material.primerType == "ToBeSynthesized") {
        return true;
      }
    }
    return false;
  }

  // To check if the barcode is of a stored primer type
  isStored(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    if (item.materialType != null && item.materialType.toString() === MaterialType.Sample.toString()) return false;
    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem == null) return false;
    let material = currentItem.containerItemAware;

    // checking if material type is primer
    if (material != null && material != undefined && material.materialType === MaterialType[3]) {
      if (material.primerType == "Stored") {
        return true;
      }
    }
    return false;
  }

  // To check if the barcode is of an enclosed primer type
  isEnclosed(i: number, j: number, item: Carrier): boolean {

    if (item == null) return false;

    if (item.materialType != null && item.materialType.toString() === MaterialType.Sample.toString()) return false;
    let selectedCarrier: Carrier = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem == null) return false;
    let material = currentItem.containerItemAware;

    // checking if material type is primer
    if (material != null && material != undefined && material.materialType === MaterialType[3]) {
      if (material.primerType == "Enclosed") {
        return true;
      }
    }
    return false;
  }

  // checking if the carrier is of type Primer
  isPrimerCarrier(item: Carrier): boolean {
    if (item == null) return false;
    if (item.materialType != null && item.materialType.toString() === MaterialType.Sample.toString()) return false;
    if (item.materialType != null && item.materialType.toString() === MaterialType.Primer.toString()) return true;
  }


  getCarrierByBarcode(barcode: string, i, j, item: Carrier) {
    let barcodeWithoutEmptySpace = barcode.replace(/\s/g, "").trim();

    if (item.carrierType != CarrierType.TUBE_CARRIER && this.isReplacement || this.isBarcodeChanged) {
      this.blocked = true;
      this.srTubeValidationRequest.carrierObjectID = item._id;
      this.srTubeValidationRequest.carrierType = item.carrierType;
      this.srTubeValidationRequest.carrierBarcode = item.barcode;
      this.srTubeValidationRequest.materialBarcode = barcodeWithoutEmptySpace;
      this.srTubeValidationRequest.positionRow = i + 1;
      this.srTubeValidationRequest.positionCol = j + 1;
      this.srTubeValidationRequest.labId = item.lab._id;
      this.srTubeValidationRequest.materialToDelete = barcodeWithoutEmptySpace == "" && this.isReplacement;
      this.carrierGridService.getCarrierByMaterialBarcode(this.srTubeValidationRequest).subscribe(
        result => {
          if (!result) {
            return;
          }
          this.selectedCarrier = result.data;
          this.updatedCarrierEmitter.emit(result.data);
          this.containerItems = this.selectedCarrier.containerItems;
          this.blocked = false;
        },
        error => {
          setTimeout(() => {
            var elem = this.renderer.selectRootElement('#' + 'textBox-' + this.selectedCarrier._id + i + j);
            this.renderer.listen(elem, "focus", () => { });
            elem.focus();
            this.renderer.setStyle(elem, "color", "red");
          }, 0);
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.blocked = false;
        })
    }

  }



  isSupremeRun(carrier: Carrier) {
    var carrierTypeArray: Array<CarrierType> = [CarrierType.PREMIXED_DNA, CarrierType.PURIFIED_DNA, CarrierType.UNPURIFIED_PCR, CarrierType.READY_TO_LOAD, CarrierType.CLONE, CarrierType.HAMILTON_CARRIER, CarrierType.SR_TUBE_CARRIER];
    return carrierTypeArray.includes(carrier.carrierType);
  }

  hasDifferentMaterial(i: number, j: number, carrier: Carrier) {

    if (carrier == null) return false;
    let selectedCarrier: Carrier = carrier;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    return currentItem != null && currentItem != undefined && currentItem.hasDifferntMaterials
  }

  getTheReceivedHamiltonFileType(carrier: Carrier) {
    return carrier.scanResultFileName != null && carrier.scanResultFileName != undefined && carrier.scanResultFileName.substring(0, 3) === "TRS"
  }

  getCarriersFromReactionPlate() {
    this.selectedA1Carrier = new Carrier();
    this.selectedA1Carrier.containerItems = new Array<ContainerItem>();
    this.selectedA2Carrier = new Carrier();
    this.selectedA2Carrier.containerItems = new Array<ContainerItem>();
    this.selectedB1Carrier = new Carrier();
    this.selectedB1Carrier.containerItems = new Array<ContainerItem>();
    this.selectedB2Carrier = new Carrier();
    this.selectedB2Carrier.containerItems = new Array<ContainerItem>();
    this.selectedReactionPlate = this.storeCarrier;

    this.selectedReactionPlate.containerItems.forEach(containerItem => {
      let ci = containerItem;
      if (this.isCarrierA1(ci.positionCol, ci.positionRow)) {
        ci.positionCol = ci.positionCol / 2 + 0.5;
        ci.positionRow = ci.positionRow / 2 + 0.5;
        this.selectedA1Carrier.containerItems.push(ci);
      } else
        if (this.isCarrierA2(ci.positionCol, ci.positionRow)) {
          ci.positionCol = ci.positionCol / 2;
          ci.positionRow = ci.positionRow / 2 + 0.5;
          this.selectedA2Carrier.containerItems.push(ci);
        } else
          if (this.isCarrierB1(ci.positionCol, ci.positionRow)) {
            ci.positionCol = ci.positionCol / 2 + 0.5;
            ci.positionRow = ci.positionRow / 2;
            this.selectedB1Carrier.containerItems.push(ci);
          } else
            if (this.isCarrierB2(ci.positionCol, ci.positionRow)) {
              ci.positionCol = ci.positionCol / 2;
              ci.positionRow = ci.positionRow / 2;
              this.selectedB2Carrier.containerItems.push(ci);
            }
    });
  }

  getA1CarrierFromReactionPlate() {
    this.headerColumnsFor384Well = this.headerColumnsA1AndB1;
    this.headerRowsFor384Well = this.headerRowsA1AndA2;
    if (this.selectedA1Carrier) {
      this.selectedQuadrant = this.selectedA1Carrier;
      this.updatedCarrierEmitter.emit(this.selectedCarrier);
    }
  }

  getA2CarrierFromReactionPlate() {
    this.headerColumnsFor384Well = this.headerColumnsA2AndB2;
    this.headerRowsFor384Well = this.headerRowsA1AndA2;
    if (this.selectedA2Carrier) {
      this.selectedQuadrant = this.selectedA2Carrier;
      this.updatedCarrierEmitter.emit(this.selectedCarrier);
    }
  }

  getB1CarrierFromReactionPlate() {
    this.headerColumnsFor384Well = this.headerColumnsA1AndB1;
    this.headerRowsFor384Well = this.headerRowsB1AndB2;
    if (this.selectedB1Carrier) {
      this.selectedQuadrant = this.selectedB1Carrier;
      this.updatedCarrierEmitter.emit(this.selectedCarrier);
    }
  }

  getB2CarrierFromReactionPlate() {
    this.headerColumnsFor384Well = this.headerColumnsA2AndB2;
    this.headerRowsFor384Well = this.headerRowsB1AndB2;
    if (this.selectedB2Carrier) {
      this.selectedQuadrant = this.selectedB2Carrier;
      this.updatedCarrierEmitter.emit(this.selectedCarrier);
    }
  }

  isCarrierA1(col: number, row: number) {
    return col % 2 != 0 && row % 2 != 0;
  }
  isCarrierA2(col: number, row: number) {
    return col % 2 == 0 && row % 2 != 0;
  }
  isCarrierB1(col: number, row: number) {
    return col % 2 != 0 && row % 2 == 0;
  }
  isCarrierB2(col: number, row: number) {
    return col % 2 == 0 && row % 2 == 0;
  }
}
